module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl1-100.15ec77fb.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl1-100.png
// module id = 3561
// module chunks = 11